import Handlebars from "handlebars";
import { createSlug } from "./app.common";

const searchForm = document.getElementById('event-list-form');
const regionSelector = document.querySelector('#region');
const searchResult = document.getElementById('search-result');
const resultContainer = document.querySelector('.tile-grid__grid');
const eventTileTemplateId = "event-tile-template";
const loadMoreButton = document.querySelector(".tile-grid__pagination button");
const backButton = document.querySelector(".js-back-button");

let currentPage = 1;
const itemsPerPage = 6;

const searchModel = {
    get region() { return regionSelector?.value }
}


const renderResult = ({ data = [] }, append = false) => {

    if (data.length === 0 && !append) {
        resultContainer.innerHTML = '<h2>No events available</h2>';
    } else {

        const source = document.getElementById(eventTileTemplateId).innerHTML;
        const template = Handlebars.compile(source);

        const preparedResults = data.map(item => ({
            ...item,
            showCpdPoints:
                item.cpdPoints != null &&
                item.cpdPoints !== '' &&
                Number(item.cpdPoints) > 0
        }));

        const htmlResults = template({ results: preparedResults });

        if (append) {
            resultContainer.innerHTML = resultContainer.innerHTML.concat(htmlResults);
        } else {
            resultContainer.innerHTML = htmlResults;
        }
    }

    searchResult.style.display = "block";

};

const fetchSearchResult = async (currentPage = 1) => {

    let requestUrl = `${window.location.protocol}//${window.location.host}/api/events`;
    const searchParams = new URLSearchParams();

    if (searchModel.region) searchParams.append('region', searchModel.region);
    searchParams.append('currentPage', currentPage);
    searchParams.append('itemsPerPage', itemsPerPage);
    requestUrl = `${requestUrl}?${searchParams.toString()}`;

    try {
        const response = await fetch(requestUrl);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();

        if (result.data) {
            result.data.forEach(event => {
                event.cpdPoints = event.cpdPoints ? event.cpdPoints : "0";
                event.date = new Date(event.date).toLocaleDateString('en-NZ', { day: '2-digit', month: 'short' });
                event.startTime = new Date(event.startTime).toLocaleTimeString('en-NZ', { hour: '2-digit', minute: '2-digit' });
                event.endTime = new Date(event.endTime).toLocaleTimeString('en-NZ', { hour: '2-digit', minute: '2-digit' });
                const eventNameSlug = createSlug(event.title);
                event.detailPageUrl = `${eventNameSlug}/${event.id}/`;
            });
        }
        return result;
    } catch (error) {
        console.error('Fetching result failed:', error);
        return null;
    }
};

const updateLoadMoreButton = (totalItems) => {
    if (currentPage < Math.ceil(totalItems / itemsPerPage)) {
        loadMoreButton.style.display = "inline-flex";
    } else {
        loadMoreButton.style.display = "none";
    }
}

const resetForm = () => {
    resultContainer.innerHTML = "";
    searchResult.style.display = "none";
}


document.addEventListener("DOMContentLoaded", async () => {

    regionSelector?.addEventListener('change', async () => {
        const result = await fetchSearchResult();
        resetForm();
        renderResult(result);
        updateLoadMoreButton(result.totalItems);
    });


    loadMoreButton?.addEventListener('click', async () => {
        const result = await fetchSearchResult(++currentPage);
        renderResult(result, true);

        updateLoadMoreButton(result.totalItems);
    });

    backButton?.addEventListener('click', () => {
        const referrer = document.referrer;
        const currentDomain = `${window.location.protocol}//${window.location.host}`;

        if (referrer.startsWith(currentDomain)) {
            window.history.back();
        } else {
            const firstPath = `${window.location.origin}/${window.location.pathname.split('/')[1]}/`;
            window.location.href = firstPath;
        }
    });

    if (searchForm) {
        const result = await fetchSearchResult();
        renderResult(result);
        updateLoadMoreButton(result.totalItems);
    }
});



